<template>
  <div class="container mx-auto">
    <el-dialog
      :close-on-click-modal="false"
      title="Nuevo posición"
      :visible.sync="showNewDepartment"
      width="450px"
    >
      <el-form
        :model="newDepartmentForm"
        status-icon
        :rules="newDepartmentFormRules"
        ref="newDepartment"
        @submit.native.prevent="
          submitNewDepartment(
            'departamento',
            'newDepartment',
            newDepartmentForm
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre del departamento" prop="name">
                  <el-input
                    placeholder="Nombre del departamento"
                    v-model="newDepartmentForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24">
                <span>Permisos</span>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="seeSubordinate">
                  <el-checkbox
                    class="w-full"
                    v-model="newDepartmentForm.seeSubordinate"
                    label="Ver empleados"
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyOvertime">
                  <el-checkbox
                    class="w-full"
                    v-model="newDepartmentForm.applyOvertime"
                    label="Asignar H.E."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyPersonalAction">
                  <el-checkbox
                    class="w-full"
                    v-model="newDepartmentForm.applyPersonalAction"
                    label="Asignar A.P."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewDepartment = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="Editar posición"
      :visible.sync="showEditDepartment"
      width="450px"
    >
      <el-form
        :model="editDepartmentForm"
        status-icon
        :rules="editDepartmentFormRules"
        ref="editDepartment"
        @submit.native.prevent="
          submitNewDepartment(
            'departamento',
            'editDepartment',
            editDepartmentForm,
            editDepartmentForm.id
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre del departamento" prop="name">
                  <el-input
                    placeholder="Nombre del departamento"
                    v-model="editDepartmentForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24">
                <span>Permisos</span>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="seeSubordinate">
                  <el-checkbox
                    class="w-full"
                    v-model="editDepartmentForm.seeSubordinate"
                    label="Ver empleados"
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyOvertime">
                  <el-checkbox
                    class="w-full"
                    v-model="editDepartmentForm.applyOvertime"
                    label="Asignar H.E."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyPersonalAction">
                  <el-checkbox
                    class="w-full"
                    v-model="editDepartmentForm.applyPersonalAction"
                    label="Asignar A.P."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditDepartment = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="Nueva posición"
      :visible.sync="showNewPosition"
      width="450px"
    >
      <el-form
        :model="newPositionForm"
        status-icon
        :rules="newPositionFormRules"
        ref="newPosition"
        @submit.native.prevent="
          submitNewDepartment('posición', 'newPosition', newPositionForm)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item
                  label="Seleccionar departamento"
                  prop="department"
                >
                  <el-select
                    filterable
                    clearable
                    v-model="newPositionForm.department"
                    placeholder="Seleccionar departamento"
                    class="w-full"
                    size="small"
                  >
                    <el-option
                      v-for="d in rawDepartments"
                      :key="d.id"
                      :label="d.name"
                      :value="d.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de la posición" prop="name">
                  <el-input
                    placeholder="Nombre de la posición"
                    v-model="newPositionForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24">
                <span>Permisos</span>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="seeSubordinate">
                  <el-checkbox
                    class="w-full"
                    v-model="newPositionForm.seeSubordinate"
                    label="Ver empleados"
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyOvertime">
                  <el-checkbox
                    class="w-full"
                    v-model="newPositionForm.applyOvertime"
                    label="Asignar H.E."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyPersonalAction">
                  <el-checkbox
                    class="w-full"
                    v-model="newPositionForm.applyPersonalAction"
                    label="Asignar A.P."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewPosition = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="Editar posición"
      :visible.sync="showEditPosition"
      width="450px"
    >
      <el-form
        :model="editPositionForm"
        status-icon
        :rules="editPositionFormRules"
        ref="editPosition"
        @submit.native.prevent="
          submitNewDepartment(
            'posición',
            'editPosition',
            editPositionForm,
            editPositionForm.id
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item
                  label="Seleccionar departamento"
                  prop="department"
                >
                  <el-select
                    filterable
                    clearable
                    v-model="editPositionForm.department"
                    placeholder="Seleccionar departamento"
                    class="w-full"
                    size="small"
                  >
                    <el-option
                      v-for="d in rawDepartments"
                      :key="d.id"
                      :label="d.name"
                      :value="d.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de la posición" prop="name">
                  <el-input
                    placeholder="Nombre de la posición"
                    v-model="editPositionForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24">
                <span>Permisos</span>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="seeSubordinate">
                  <el-checkbox
                    class="w-full"
                    v-model="editPositionForm.seeSubordinate"
                    label="Ver empleados"
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyOvertime">
                  <el-checkbox
                    class="w-full"
                    v-model="editPositionForm.applyOvertime"
                    label="Asignar H.E."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8" class="flex flex-col justify-center">
                <el-form-item prop="applyPersonalAction">
                  <el-checkbox
                    class="w-full"
                    v-model="editPositionForm.applyPersonalAction"
                    label="Asignar A.P."
                    border
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditPosition = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">ESTRUCTURA ORGANIZACIONAL</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran los diferentes departamentos que se utilizan en el sistema."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="primary"
              size="small"
              @click="openNewDepartmentDialog"
              >Nuevo departamento</el-button
            >
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Buscar"
              v-model="searchDepartment"
              size="small"
              suffix-icon="el-icon-search"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-table
              v-if="rawDepartments.length == filteredDepartments.length"
              row-key="id"
              :data="filteredDepartments"
              stripe
              size="mini"
            >
              <el-table-column
                prop="name"
                label="Nombre de departamento"
                min-width="600"
              />
              <el-table-column
                prop="name"
                label="Ver empleados"
                min-width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.seeSubordinate ? "Si" : "No" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="Asignar H.E."
                min-width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.applyOvertime ? "Si" : "No" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="Asignar A.P."
                min-width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.applyPersonalAction ? "Si" : "No" }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado" min-width="90" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.active">
                    <el-tag type="success" size="small">Activo</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">Inactivo</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="90" align="center">
                <template slot-scope="scope">
                  <div class="flex justify-center">
                    <el-button
                      icon="el-icon-plus"
                      type="primary"
                      size="small"
                      class="mr-2"
                      @click.native="openNewPositionDialog(scope.row.id)"
                    />
                    <el-dropdown trigger="click">
                      <el-button
                        icon="el-icon-fa-ellipsis-v"
                        size="small"
                      ></el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          @click.native="openEditDepartmentDialog(scope.row)"
                        >
                          <i class="el-icon-fa-pencil"></i> Editar información
                        </el-dropdown-item>
                        <el-dropdown-item
                          @click.native="changeStatusDepartment(scope.row)"
                        >
                          <span v-if="scope.row.active">
                            <i class="el-icon-fa-times"></i> Desactivar
                          </span>
                          <span v-else>
                            <i class="el-icon-fa-check"></i> Activar
                          </span>
                          registro
                        </el-dropdown-item>
                        <el-dropdown-item
                          :divided="true"
                          class="text-red-500 font-semibold"
                          @click.native="deleteDepartment(scope.row)"
                        >
                          <i class="el-icon-fa-trash"></i> Eliminar
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-table v-else :data="filteredDepartments" stripe size="mini">
              <el-table-column
                prop="name"
                label="Nombre de departamento"
                min-width="600"
              />
              <el-table-column
                prop="name"
                label="Ver empleados"
                min-width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.seeSubordinate ? "Si" : "No" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="Asignar H.E."
                min-width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.applyOvertime ? "Si" : "No" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="Asignar A.P."
                min-width="80"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.applyPersonalAction ? "Si" : "No" }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado" min-width="90" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.active">
                    <el-tag type="success" size="small">Activo</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">Inactivo</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="90" align="center">
                <template slot-scope="scope">
                  <div class="flex justify-center">
                    <el-button
                      icon="el-icon-plus"
                      type="primary"
                      size="small"
                      class="mr-2"
                      @click.native="openNewPositionDialog(scope.row.id)"
                    />
                    <el-dropdown trigger="click">
                      <el-button
                        icon="el-icon-fa-ellipsis-v"
                        size="small"
                      ></el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          @click.native="openEditDepartmentDialog(scope.row)"
                        >
                          <i class="el-icon-fa-pencil"></i> Editar información
                        </el-dropdown-item>
                        <el-dropdown-item
                          @click.native="changeStatusDepartment(scope.row)"
                        >
                          <span v-if="scope.row.active">
                            <i class="el-icon-fa-times"></i> Desactivar
                          </span>
                          <span v-else>
                            <i class="el-icon-fa-check"></i> Activar
                          </span>
                          registro
                        </el-dropdown-item>
                        <el-dropdown-item
                          :divided="true"
                          class="text-red-500 font-semibold"
                          @click.native="deleteDepartment(scope.row)"
                        >
                          <i class="el-icon-fa-trash"></i> Eliminar
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChangeDepartment"
            :current-page.sync="pageDepartment.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="pageDepartment.size"
            layout="total, sizes, prev, pager, next"
            :total="rawDepartments.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";
import { sortPropertyName } from "./../../../utils";

export default {
  name: "SettingsDepartmentsPositions",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{ 
          departments 
          { 
            id name active seeSubordinate applyOvertime applyPersonalAction
            children { 
              id name active seeSubordinate applyOvertime applyPersonalAction
              children { 
                id name active seeSubordinate applyOvertime applyPersonalAction
                children { 
                  id name active seeSubordinate applyOvertime applyPersonalAction
                  children { 
                    id name active seeSubordinate applyOvertime applyPersonalAction
                    children { 
                      id name active seeSubordinate applyOvertime applyPersonalAction
                      children { 
                        id name active seeSubordinate applyOvertime applyPersonalAction
                        children { 
                          id name active seeSubordinate applyOvertime applyPersonalAction
                          children { 
                            id name active seeSubordinate applyOvertime applyPersonalAction
                            children { 
                              id name active seeSubordinate applyOvertime applyPersonalAction
                              children { 
                                id name active seeSubordinate applyOvertime applyPersonalAction
                                children { 
                                  id name active seeSubordinate applyOvertime applyPersonalAction
                                  children { 
                                    id name active seeSubordinate applyOvertime applyPersonalAction
                                    children { 
                                      id name active seeSubordinate applyOvertime applyPersonalAction
                                    } 
                                    parentDepartment { id }   
                                  } 
                                  parentDepartment { id }   
                                } 
                                parentDepartment { id }   
                              } 
                              parentDepartment { id }   
                            } 
                            parentDepartment { id }   
                          } 
                          parentDepartment { id }   
                        } 
                        parentDepartment { id }   
                      } 
                      parentDepartment { id }   
                    } 
                    parentDepartment { id }   
                  } 
                  parentDepartment { id }   
                } 
                parentDepartment { id } 
              } 
              parentDepartment { id } 
            } 
            parentDepartment { id } 
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.departments));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      rawDepartments: [],
      searchDepartment: "",
      pageDepartment: {
        size: 15,
        number: 1,
      },
      showNewDepartment: false,
      showNewPosition: false,
      newDepartmentForm: {
        name: "",
        seeSubordinate: false,
        applyOvertime: false,
        applyPersonalAction: false,
      },
      newDepartmentFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
      },
      newPositionForm: {
        name: "",
        department: "",
        seeSubordinate: false,
        applyOvertime: false,
        applyPersonalAction: false,
      },
      newPositionFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            message: "Por favor selecciona un departamento.",
            trigger: "change",
          },
        ],
      },
      showEditDepartment: false,
      showEditPosition: false,
      editDepartmentForm: {
        name: "",
        seeSubordinate: false,
        applyOvertime: false,
        applyPersonalAction: false,
      },
      editDepartmentFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
      },
      editPositionForm: {
        name: "",
        department: "",
        seeSubordinate: false,
        applyOvertime: false,
        applyPersonalAction: false,
      },
      editPositionFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            message: "Por favor selecciona un departamento.",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    setData(dataDepartment) {
      this.rawDepartments = dataDepartment.map((d) => {
        const children = d.children;
        delete d.children;
        return {
          ...d,
          children,
        };
      });
    },
    handleSizeChangeDepartment(val) {
      this.pageDepartment.size = val;
    },
    changeStatusDepartment(department) {
      const action = department.active ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} este registro?`;
      const saveText = `Si, ${V.titleCase(action)}`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: saveText,
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  departmentUpdateStatus
                  ( where: { id: ${
                    department.id
                  } } active: ${!department.active} )
                  { 
                    id name active seeSubordinate applyOvertime applyPersonalAction
                    children { 
                      id name active seeSubordinate applyOvertime applyPersonalAction
                      children { 
                        id name active seeSubordinate applyOvertime applyPersonalAction
                        children { 
                          id name active seeSubordinate applyOvertime applyPersonalAction
                          children { 
                            id name active seeSubordinate applyOvertime applyPersonalAction
                            children { 
                              id name active seeSubordinate applyOvertime applyPersonalAction
                              children { 
                                id name active seeSubordinate applyOvertime applyPersonalAction
                                children { 
                                  id name active seeSubordinate applyOvertime applyPersonalAction
                                  children { 
                                    id name active seeSubordinate applyOvertime applyPersonalAction
                                    children { 
                                      id name active seeSubordinate applyOvertime applyPersonalAction
                                      children { 
                                        id name active seeSubordinate applyOvertime applyPersonalAction
                                        children { 
                                          id name active seeSubordinate applyOvertime applyPersonalAction
                                          children { 
                                            id name active seeSubordinate applyOvertime applyPersonalAction
                                            children { 
                                              id name active seeSubordinate applyOvertime applyPersonalAction
                                            } 
                                            parentDepartment { id }   
                                          } 
                                          parentDepartment { id }   
                                        } 
                                        parentDepartment { id }   
                                      } 
                                      parentDepartment { id }   
                                    } 
                                    parentDepartment { id }   
                                  } 
                                  parentDepartment { id }   
                                } 
                                parentDepartment { id }   
                              } 
                              parentDepartment { id }   
                            } 
                            parentDepartment { id }   
                          } 
                          parentDepartment { id }   
                        } 
                        parentDepartment { id } 
                      } 
                      parentDepartment { id } 
                    } 
                    parentDepartment { id } 
                  }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawDepartments = data.departmentUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha cambiado el estado correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = saveText;
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    deleteDepartment({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este registro?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { 
                    departmentDelete( where: {id: ${id}} ) 
                    { 
                      id name active seeSubordinate applyOvertime applyPersonalAction
                      children { 
                        id name active seeSubordinate applyOvertime applyPersonalAction
                        children { 
                          id name active seeSubordinate applyOvertime applyPersonalAction
                          children { 
                            id name active seeSubordinate applyOvertime applyPersonalAction
                            children { 
                              id name active seeSubordinate applyOvertime applyPersonalAction
                              children { 
                                id name active seeSubordinate applyOvertime applyPersonalAction
                                children { 
                                  id name active seeSubordinate applyOvertime applyPersonalAction
                                  children { 
                                    id name active seeSubordinate applyOvertime applyPersonalAction
                                    children { 
                                      id name active seeSubordinate applyOvertime applyPersonalAction
                                      children { 
                                        id name active seeSubordinate applyOvertime applyPersonalAction
                                        children { 
                                          id name active seeSubordinate applyOvertime applyPersonalAction
                                          children { 
                                            id name active seeSubordinate applyOvertime applyPersonalAction
                                            children { 
                                              id name active seeSubordinate applyOvertime applyPersonalAction
                                              children { 
                                                id name active seeSubordinate applyOvertime applyPersonalAction
                                              } 
                                              parentDepartment { id }   
                                            } 
                                            parentDepartment { id }   
                                          } 
                                          parentDepartment { id }   
                                        } 
                                        parentDepartment { id }   
                                      } 
                                      parentDepartment { id }   
                                    } 
                                    parentDepartment { id }   
                                  } 
                                  parentDepartment { id }   
                                } 
                                parentDepartment { id }   
                              } 
                              parentDepartment { id }   
                            } 
                            parentDepartment { id }   
                          } 
                          parentDepartment { id } 
                        } 
                        parentDepartment { id } 
                      } 
                      parentDepartment { id } 
                    }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawDepartments = data.departmentDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado este departamento correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openNewDepartmentDialog() {
      const ref = this.$refs["newDepartment"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
      this.showNewDepartment = true;
    },
    openEditDepartmentDialog(registry) {
      const {
        id,
        parentDepartment,
        name,
        seeSubordinate,
        applyOvertime,
        applyPersonalAction,
      } = registry;
      if (R.isNil(parentDepartment)) {
        const ref = this.$refs["editDepartment"];
        if (!R.isNil(ref)) {
          ref.resetFields();
        }
        this.editDepartmentForm.id = id;
        this.editDepartmentForm.name = name;
        this.editDepartmentForm.seeSubordinate = seeSubordinate;
        this.editDepartmentForm.applyOvertime = applyOvertime;
        this.editDepartmentForm.applyPersonalAction = applyPersonalAction;
        this.showEditDepartment = true;
      } else {
        const ref = this.$refs["editPosition"];
        if (!R.isNil(ref)) {
          ref.resetFields();
        }
        this.editPositionForm.id = id;
        this.editPositionForm.name = name;
        this.editPositionForm.seeSubordinate = seeSubordinate;
        this.editPositionForm.applyOvertime = applyOvertime;
        this.editPositionForm.applyPersonalAction = applyPersonalAction;
        this.editPositionForm.department = parentDepartment.id;
        this.showEditPosition = true;
      }
    },
    submitNewDepartment(
      type,
      formName,
      { name, department, seeSubordinate, applyOvertime, applyPersonalAction },
      departmentId = false
    ) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = departmentId ? "editar" : "crear";

        let departmentText = !R.isNil(department) ? `"${department}"` : null;
        const mutation = departmentId
          ? `departmentEdit(
              data: { 
                name: "${name}" 
                parentDepartment: ${departmentText}
                seeSubordinate: ${seeSubordinate}
                applyOvertime: ${applyOvertime}
                applyPersonalAction: ${applyPersonalAction}
              } 
              where: { id: ${departmentId} } 
            )`
          : `departmentCreate(
              data: { 
                name: "${name}" 
                parentDepartment: ${departmentText}
                seeSubordinate: ${seeSubordinate}
                applyOvertime: ${applyOvertime}
                applyPersonalAction: ${applyPersonalAction}
              } 
            )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} este ${type}?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      ${mutation}
                      { 
                        id name active seeSubordinate applyOvertime applyPersonalAction
                        children { 
                          id name active seeSubordinate applyOvertime applyPersonalAction
                          children { 
                            id name active seeSubordinate applyOvertime applyPersonalAction
                            children { 
                              id name active seeSubordinate applyOvertime applyPersonalAction
                              children { 
                                id name active seeSubordinate applyOvertime applyPersonalAction
                                children { 
                                  id name active seeSubordinate applyOvertime applyPersonalAction
                                  children { 
                                    id name active seeSubordinate applyOvertime applyPersonalAction
                                    children { 
                                      id name active seeSubordinate applyOvertime applyPersonalAction
                                      children { 
                                        id name active seeSubordinate applyOvertime applyPersonalAction
                                        children { 
                                          id name active seeSubordinate applyOvertime applyPersonalAction
                                          children { 
                                            id name active seeSubordinate applyOvertime applyPersonalAction
                                            children { 
                                              id name active seeSubordinate applyOvertime applyPersonalAction
                                              children { 
                                                id name active seeSubordinate applyOvertime applyPersonalAction
                                                children { 
                                                  id name active seeSubordinate applyOvertime applyPersonalAction
                                                } 
                                                parentDepartment { id }   
                                              } 
                                              parentDepartment { id }   
                                            } 
                                            parentDepartment { id }   
                                          } 
                                          parentDepartment { id }   
                                        } 
                                        parentDepartment { id }   
                                      } 
                                      parentDepartment { id }   
                                    } 
                                    parentDepartment { id }   
                                  } 
                                  parentDepartment { id }   
                                } 
                                parentDepartment { id }   
                              } 
                              parentDepartment { id }   
                            } 
                            parentDepartment { id } 
                          } 
                          parentDepartment { id } 
                        } 
                        parentDepartment { id } 
                      }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      const values = departmentId
                        ? data.departmentEdit
                        : data.departmentCreate;
                      this.rawDepartments = values.map((d) => {
                        const children = d.children;
                        delete d.children;
                        return {
                          ...d,
                          children,
                        };
                      });
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha ${
                            departmentId ? "editado" : "creado"
                          } el ${type} correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewDepartment = false;
                    this.showEditDepartment = false;
                    this.showNewPosition = false;
                    this.showEditPosition = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    openNewPositionDialog(parentId) {
      const ref = this.$refs["newPosition"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
      this.newPositionForm.department = parentId;
      this.showNewPosition = true;
    },
  },
  computed: {
    filteredDepartments() {
      const search = this.searchDepartment.toLowerCase();
      const values = this.rawDepartments.map((d) => {
        const children = sortPropertyName("name")(d.children);
        return {
          ...d,
          children,
        };
      });
      let departments;

      if (search != "" && search.length > 3) {
        departments = values.filter((d) =>
          d.name.toLowerCase().includes(search)
        );
      } else {
        departments = values
          .filter((d) => R.isNil(d.parentDepartment))
          .slice(
            this.pageDepartment.number * this.pageDepartment.size -
              this.pageDepartment.size,
            this.pageDepartment.size * this.pageDepartment.number
          );
      }

      return departments;
    },
  },
};
</script>
